function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogleMeet = function SvgGoogleMeet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 101.11",
    style: {
      enableBackground: "new 0 0 122.88 101.11"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#188038"
    },
    d: "m69.51 50.56 11.98 13.69L97.6 74.54l2.81-23.89-2.81-23.37-16.42 9.04-11.67 14.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 72.32v20.36c0 4.66 3.77 8.43 8.43 8.43h20.36L33 85.72l-4.21-13.4-13.97-4.21L0 72.32z",
    style: {
      fill: "#1967d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ea4335"
    },
    d: "M28.79 0 0 28.79 14.82 33l13.97-4.21 4.14-13.22L28.79 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4285f4"
    },
    d: "M0 72.32h28.79V28.79H0v43.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.99 12.19 97.6 27.28v47.26l18.47 15.15c2.77 2.16 6.81.19 6.81-3.32V15.45c0-3.56-4.14-5.51-6.89-3.26zM69.51 50.56v21.77H28.79v28.79h60.39c4.66 0 8.43-3.77 8.43-8.43V74.54l-28.1-23.98z",
    style: {
      fill: "#34a853"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.18 0H28.79v28.79h40.73v21.77L97.6 27.28V8.43C97.6 3.77 93.83 0 89.18 0z",
    style: {
      fill: "#fbbc04"
    }
  }));
};
export default SvgGoogleMeet;